import { Modal } from "@cntrl/ui";
import { useOrgCapability } from "../../app/orgContext.js";
import { OrgTeamPanel, OrgTeamActions } from "./OrgTeamScreen.js";

export interface TeamModalProps {
  onClose: () => void;
}

/**
 * Team as a modal — the normal way in, opened from the roster shell's account chip, mirroring the ruling
 * that put Settings behind the topbar gear (2026-08-17).
 *
 * The `/roster/team` ROUTE deliberately survives as a full page (a bookmark; a surface a narrow shell can
 * route to). So this is a second *chrome*, never a second implementation — both mount `OrgTeamPanel` and
 * `OrgTeamActions`, which is where the capability gate, the reads and every state live, so the two can never
 * drift on who may see what. What differs is PLACEMENT: the dialog pins the actions in its footer, where they
 * stay put while the roster scrolls; the page puts them beside its H1.
 *
 * `lg` (560), not the Settings workbench's `2xl`: a member row is an avatar, a name, a role and a couple of
 * chips, and at 960 the roster was a column of short rows floating in half a screen of white.
 *
 * The capability is re-checked here to decide whether the footer slot exists AT ALL. `Modal` renders the
 * footer whenever the prop is non-null, and a component that returns null is still a non-null element — so
 * passing it unconditionally would draw an empty bordered bar under the roster for every seat that cannot
 * invite.
 */
export function TeamModal({ onClose }: TeamModalProps) {
  const canManage = useOrgCapability("roster:manage_seats");
  return (
    <Modal title="Team" size="lg" onClose={onClose} footer={canManage ? <OrgTeamActions /> : undefined}>
      <OrgTeamPanel />
    </Modal>
  );
}
